// t() reads the page language, which the compiler cannot see, and this stays
// on screen while the language changes.
"use no memo";
import { useId } from "react";
import CaretDown from "~icons/ph/caret-down";
import Check from "~icons/ph/check";
import type { Availability } from "../../shared/types";
import { t } from "../i18n";

const labels: Record<Availability, string> = {
  online: "متصل",
  busy: "مشغول",
  offline: "غير متصل",
};
const statuses: Availability[] = ["online", "busy", "offline"];

export function StatusMenu({
  status,
  busy,
  onChange,
}: {
  status: Availability;
  busy: boolean;
  onChange: (status: Availability) => void;
}) {
  const menuId = useId();
  return (
    <div className="status-menu">
      <button
        type="button"
        className={`status-menu-trigger ${status}`}
        popoverTarget={menuId}
        aria-label={t("حالتك: {status}", { status: t(labels[status]) })}
      >
        {t(labels[status])}
        <CaretDown width={14} height={14} />
      </button>
      <div id={menuId} popover="auto" className="person-menu-items">
        {statuses.map((value) => (
          <button
            key={value}
            type="button"
            className={value}
            aria-current={value === status || undefined}
            popoverTarget={menuId}
            popoverTargetAction="hide"
            // Disabling the button mid-click would keep the menu from closing.
            onClick={() => {
              if (!busy && value !== status) onChange(value);
            }}
          >
            {t(labels[value])}
            {value === status && <Check width={14} height={14} />}
          </button>
        ))}
      </div>
    </div>
  );
}
